import { fromJS } from 'immutable';
import * as ActionTypes from '../constants/ActionTypes';

const authState = fromJS({
  loading: true,
  reset: false,
  user: {
    id: null,
    first_name: '',
    last_name: '',
    email: '',
    patient_id: '',
    isLoggedIn: false,
    access_token: null
  }
});

function setState(state, newState) {
  return state.merge(newState);
}

export default function auth(state = authState, action) {
  switch(action.type) {
    case ActionTypes.LOADING:
      return setState(state, state.set('loading', action.payload));

    case ActionTypes.LOGIN:
      return setState(state, state.withMutations(map => map
        .setIn(['user', 'access_token'], action.payload.access_token)
        .setIn(['user', 'patient_id'], action.payload.patient_id)
        .setIn(['user', 'first_name'], action.payload.first_name)
        .setIn(['user', 'last_name'], action.payload.last_name)
        .setIn(['user', 'email'], action.payload.email)
        .setIn(['user', 'isLoggedIn'], true)
      ));

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js